
export interface TransPair {
  lang: string;
  text: string;
}

export interface TransSet {
  cs?: string;
  en?: string;
  de?: string;
  km?: string;
}

export type TransUnit = string | TransPair[] | TransSet;

function replaceAnd(value: string, lang: string) {
  const positionOfAnd = value.indexOf(' and ');
  if (positionOfAnd > 2 && lang !== 'en') {
    let transAnd: string;
    if (lang == 'cs') transAnd = ' a '
    else if (lang == 'de') transAnd = ' und '
    else if (lang == 'km') transAnd = ' នឺង '
    else transAnd = 'en';
    const replacedAnd = value.slice(0, positionOfAnd+1) +
      value.slice(positionOfAnd-1).replace(' and ', transAnd);
    return replacedAnd;
  }
  return value;
}
export function transOilOnCanvas(value : string = "") : TransSet {
  let valueStr = value.length > 0 ? (", " + value) : "";
  return {
    en: "oil on canvas" + valueStr,
    de: "Öl auf Leinwand" + replaceAnd(valueStr, 'de'),
    cs: "olej na plátně" + replaceAnd(valueStr, 'cs'),
    km: "ប្រេងលើផ្ទាំងក្រណាត់" + replaceAnd(valueStr, 'kh'),
  };
}

export function transOlejomalbaOnCanvas(value : string = "") : TransSet {
  let result = transOilOnCanvas(value) ;
  let valueStr = value.length > 0 ? (", " + value) : "";
  result.cs = "olejomalba na plátně" + valueStr;
  return result;
}
